import { createAction, props } from '@ngrx/store';

export const put = createAction(
  'PUT_NOTICE_LAST_EDITED',
  props<{ rsNoticeId: number; noticeLastEdited: string }>()
);
export const remove = createAction('REMOVE_NOTICE_LAST_EDITED', props<{ rsNoticeId: number }>());
